import Routes from './routes'
import Router from './router'

export default Router
export {
    Routes
}